import { Col, Divider, Slider } from 'antd';
import Title from 'antd/es/typography/Title';


const RangeSlider = ({
    title,
    value,
    minvalue,
    maxvalue,
    onchange,
    showselectedvalue
}:{
    title:string,
    value:number,
    minvalue:number,
    maxvalue:number,
    onchange:(value:number)=>void,
    showselectedvalue:boolean
}) => {
  return (
    <Col>
      <Title
            level={5}
            style={{ marginBlock: 0}}>
            {title}
    </Title>
    <Divider/>
     <Slider
        min={minvalue}
        max={maxvalue}
        onChange={(val) => {
          onchange(val)
        }}
        value={value}
     />
     {
      showselectedvalue && (
        <Title level={3} style={{ marginBlock: 0,display:"flex",justifyContent:"end" }}>
           ({value} / {maxvalue})
       </Title>
      )
     }
    </Col>
  )
}

export default RangeSlider